import { render, staticRenderFns } from "./vGenericErrorTable.vue?vue&type=template&id=2c73551c&scoped=true"
import script from "./vGenericErrorTable.vue?vue&type=script&lang=ts"
export * from "./vGenericErrorTable.vue?vue&type=script&lang=ts"
import style0 from "./vGenericErrorTable.vue?vue&type=style&index=0&id=2c73551c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c73551c",
  null
  
)

export default component.exports